import { Injectable, signal } from '@angular/core';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { LogoOverlayLoader } from 'shared/components/particles/loaders/logo-overlay-loader/logo-overlay-loader';

@Injectable({ providedIn: 'root' })
export class LoaderService {
  private _loading = signal(false);
  loading = this._loading.asReadonly();

  public pendingRequests: number = 0;

  // Overlay reference
  private overlayRef: OverlayRef | null = null;

  constructor(private overlay: Overlay) {}

  show() {
    this._loading.set(true);

    if (!this.overlayRef) {
      this.overlayRef = this.overlay.create({
        hasBackdrop: true,
        backdropClass: 'global-loader-backdrop',
        panelClass: 'global-loader-panel',
        positionStrategy: this.overlay.position()
          .global()
          .centerHorizontally()
          .centerVertically()
      });
    }

    if (!this.overlayRef.hasAttached()) {
      this.overlayRef.attach(new ComponentPortal(LogoOverlayLoader));
    }
  }

  hide() {
    this._loading.set(false);
    this.overlayRef?.detach();
  }

  get doPendingRequestsExist() {
    return this.pendingRequests > 0;
  }
}
